/**
 * Returns the style options for the form graphs
 * 
 * @return options for most of the line graph
 */
export function retFormChartOptions(name) {
    return {
        responsive: true, 
        maintainAspectRatio: false,
        indexAxis: 'x',
        tension: 0.25,

        plugins: {
            title: {
                display: false,
                align: 'start',
                font: {
                    color:'#622',
                    size: 20
                },
                text: name,   
            }
            ,
            interaction: {
                mode: 'index',
                intersect: false
            },

            legend: {
                title: {
                    display: true,
                    text: 'Date',
                    align: screenLeft,
                
                },
                text: 'Number of Clients',
                labels: {
                    font: {
                        size: 13
                    },
                    usePointStyle: true,
                },
                position: 'bottom'
            }
        },



        scales: {
            y: {
                beginAtZero: true,
                max: 5,
                display: true,
                title: {
                    display: true,
                    text: 'Star Value'
                },
                ticks: {
                    min: 0,
                    max: 5,
                    stepValue: 1
                }
            },
            x: {
                display: true,
                title: {
                    display: false,
                    text: 'Date'
                }
            },
        },
    }

}


/**
 * Returns the style options for the forms graph
 * 
 * @return options for bar graph
 */
 export function retFormBarOptions() {
    return {
        responsive: true, 
        maintainAspectRatio: false,
        indexAxis: 'y',
        title: {
            display: true,
            text: 'Your History Results',   
            fontSize: 20,
        },
        scales: {
            yAxes: [{
                scaleLabel: {
                    display: true,
                    labelString: 'Yes/No'
                },
                ticks: {
                    callback:function(value){
                        if (value == 1) return "True";
                        if (value == 0) return "False";
                    }
                }
            }],
        },
        legend: {
            title: {
                display: true,
                text: 'Referral Source',
            
            },
            text: 'Number of Clients',
            labels: {
            fontSize: 13,
            usePointStyle: true,
            },
            position: 'bottom'
        }
    }
}


/**
 * Returns the style options for the TeltiKahurangi Form selection question graph
 * 
 * @return options for selection questions graph
 */
export function selFormChartOptions(name) {
    return {
        responsive: true, 
        maintainAspectRatio: false,
        indexAxis: 'x',
        title: {
            display: true,
            text: name,   
            fontSize: 20,
        },
        scales: {
            yAxes: [{
                ticks: {
                    callback:function(value){
                        if (value == 1) return "Yes";
                        if (value == 0) return "No";
                    }
                }
            }],
        },


        legend: {
            title: {
                display: true,
                text: 'Date',
            
            },
            text: 'Number of Clients',
            labels: {
            fontSize: 13,
            usePointStyle: true,
            },
            position: 'bottom'
        }
    }
}



/**
 * Returns the style options for the TeltiKahurangi Form selection question graph
 * 
 * @return options for selection questions graph
 */
export function retFormRadarOptions(name) {
    return {
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: false,
                text: name,
                font: {
                    size: 20
                },
                align: 'start'
            },
            legend: {
                title: {
                    display: true,
                    text: 'Date Completed',
                },
                labels: {
                    font: {
                        size: 16
                    },
                    usePointStyle: true,
                },
                position: 'bottom'
            }
        },
        scales: {
            r: {
                beginAtZero: true,
                min: 0,
                max: 5,
                ticks: {
                    stepSize: 1,
                    font: {
                        size: 12
                    }
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)'
                },
                angleLines: {
                    color: 'rgba(0, 0, 0, 0.1)'
                },
                pointLabels: {
                    font: {
                        size: 14
                    }
                }
            }
        }
    }
}